import { render, staticRenderFns } from "./DeveloperBlacklist.vue?vue&type=template&id=8a89422c&scoped=true"
import script from "./DeveloperBlacklist.vue?vue&type=script&lang=js"
export * from "./DeveloperBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a89422c",
  null
  
)

export default component.exports